import React, { useState } from 'react';
import ViewFreePeriodRequests from './ViewFreePeriodRequests';
import { Stepper, GetInfo } from '@operations/shared';

export const SuspendFreePeriodOffers: React.FC = () => {
    const [componentSteps] = useState([
        {
            title: 'Select Company',
            content: <GetInfo apiLink='companies/getOneCompany/' isAllCompanies />,
            id: 0,
        },

        {
            title: 'All free period requests',
            content: <ViewFreePeriodRequests />,
            id: 1,
        },
    ]);

    return (
        <>
            <Stepper componentSteps={componentSteps} />
        </>
    );
};

